import {Box, Checkbox, Typography} from '@mui/material';
import React from 'react';

export const DetectionsLegend = ({classes, filterValues, onClassToggle}) => {
  // if no classes toggles provided, render simple legend
  if (!onClassToggle) {
    return classes.map(cls => (
      <Box
        key={cls.name}
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            minWidth: 16,
            maxWidth: 16,
            minHeight: 16,
            maxHeight: 16,
            borderRadius: 4,
            bgcolor: cls.color,
            marginRight: 0.5,
            marginLeft: 1.5,
          }}
        >
          &nbsp;
        </Box>
        <Box>
          <Typography variant="caption">{cls.name}</Typography>
        </Box>
      </Box>
    ));
  }

  return classes.map(cls => {
    const checked =
      !filterValues?.classes || filterValues.classes.length === 0
        ? true
        : filterValues.classes.includes(cls.name);
    return (
      <Box
        key={cls.name}
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Checkbox
          size="small"
          checked={checked}
          onChange={evt => onClassToggle(cls.name, evt.target.checked)}
          slotProps={{
            input: {
              'aria-label': `Toggle ${cls.name}`,
            },
          }}
        />
        <Box
          sx={{
            minWidth: 16,
            maxWidth: 16,
            minHeight: 16,
            maxHeight: 16,
            borderRadius: 4,
            bgcolor: cls.color,
            marginRight: 0.5,
            marginLeft: 0.5,
          }}
        >
          &nbsp;
        </Box>
        <Typography variant="caption">{cls.name}</Typography>
      </Box>
    );
  });
};

export default DetectionsLegend;
